import { useEffect } from "react";

function loadScript(src, { bust = false } = {}) {
  return new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.src = bust ? `${src}?v=${Date.now()}` : src;
    el.async = false;
    el.onload = () => resolve(true);
    el.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.body.appendChild(el);
  });
}

function patchDownloadFormId() {
  // Legacy `static/js/report.js` expects `document.getElementById('download')`.
  // `views/report.ejs` renders the "Download your report" submit button, but without id on the form.
  const inputs = Array.from(document.querySelectorAll('input[type="submit"]'));
  const downloadInput = inputs.find((inp) => {
    const v = (inp.value || inp.getAttribute("value") || "").trim();
    return v.toLowerCase() === "download your report";
  });

  const form = downloadInput?.closest("form");
  if (form && form.id !== "download") {
    form.id = "download";
  }
}

export default function useLegacyReportScripts(enabled = true) {
  useEffect(() => {
    if (!enabled) return;

    try {
      patchDownloadFormId();
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn("[legacy-report-scripts] patch issue:", e);
    }

    // Re-load so the script binds against the currently injected DOM.
    (async () => {
      try {
        await loadScript("/js/report.js", { bust: true });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("[legacy-report-scripts] load issue:", e);
      }
    })();
  }, [enabled]);
}

